module.exports = __webpack_public_path__ + "static/media/winston.5481aa26.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/winston.webp
// module id = 321
// module chunks = 0